import { createAction } from '@reduxjs/toolkit';

export const StateResetAction = createAction<string>('STATE__RESET');
